export default __webpack_public_path__ + "static/media/spinner.44e7ba31.gif";